import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable, of, switchMap, take } from 'rxjs';

import { injectAuthFeature } from '@mymill/core/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthBypassGuard {
  private readonly authFeature = injectAuthFeature();

  /**
   * constructor
   *
   */
  constructor(/*private authStoreService: AuthStoreService*/) {}

  /**
   * canActivate
   *
   */
  public canActivate(
    route: ActivatedRouteSnapshot,
    routeState: RouterStateSnapshot,
  ): Observable<boolean> {
    const runLoginInComplete = route.data.runLoginInComplete;

    if (!this.authFeature.isReady() && !this.authFeature.mustBypass())
      this.authFeature.bypassLogin(runLoginInComplete);

    return this.authFeature.state$.pipe(
      take(1),
      switchMap((state) => {
        if (!state.isReady && !state.mustBypass) {
          this.authFeature.bypassLogin(runLoginInComplete);
        }

        return of(true);
      }),
    );
  }
}
